import { inject, Injectable } from '@angular/core';
import { JobService } from '../services/job.service';

@Injectable({
  providedIn: 'root'
})
export class CleanActiveJobHelper {
  private jobService = inject(JobService);

  clearSessionStorageFromActiveJob() {
    this.jobService.activeJobId = null;
    sessionStorage.removeItem('activeJobId');
    sessionStorage.removeItem('searchCriteria');
    sessionStorage.removeItem('previousUrl');
  }
}
